import { render, staticRenderFns } from "./RirekishoShortPreview.vue?vue&type=template&id=8a8d02ac"
import script from "./RirekishoShortPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoShortPreview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports